export const PROVIDER_CAPABILITY_STATUSES = ['yes', 'no', 'unknown'] as const;

export type ProviderCapabilityStatus =
  (typeof PROVIDER_CAPABILITY_STATUSES)[number];

export type ProviderCapabilityGroup =
  | 'provider_types'
  | 'transport_modes'
  | 'services'
  | 'shipment_types'
  | 'commodity_groups'
  | 'associations'
  | 'certifications';

/** Status used when recognition does not provide enough evidence. */
export const PROVIDER_CAPABILITY_INSUFFICIENT_EVIDENCE_STATUS: Record<
  ProviderCapabilityGroup,
  Exclude<ProviderCapabilityStatus, 'yes'>
> = {
  provider_types: 'no',
  transport_modes: 'no',
  services: 'unknown',
  shipment_types: 'unknown',
  commodity_groups: 'unknown',
  associations: 'unknown',
  certifications: 'unknown',
};
